const UserCampaignApp = () => import(/* webpackChunkName: "UserCampaignApp" */ './containers/UserCampaignApp');
const UserCampaignList = () => import(/* webpackChunkName: "UserCampaignList" */ './components/UserCampaignList');
const UserCampaignCreate = () => import(/* webpackChunkName: "UserCampaignCreate" */ './components/UserCampaignCreate');

export const userCampaignRouting = [
    {
        path: 'user-campaign', name: 'user-campaign', component: UserCampaignApp,
        children: [
            { path: '/', redirect: 'user-campaign-list' },
            { path: 'user-campaign-list', name: 'user-campaign-list', component: UserCampaignList },
            { path: 'user-campaign-create', name: 'user-campaign-create', component: UserCampaignCreate },
        ]
    }
]